import React from "react";

const TagLayoutInfo = props => {
    return (
        <React.Fragment>
            {
                props.tag !== null && <React.Fragment><div className="">
                    {props.tag.path && (
                        <img
                            src={process.env.REACT_APP_S3_THUMBNAIL_PATH + props.tag.path}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "140px",
                                margin: "0 auto"
                            }}
                            alt={props.tag.title}
                        />
                    )}
                </div>
                    <div className="brandName ml-md text_16">
                        <div>
                            Title: <strong className="medium">{props.tag.title}</strong>
                        </div>
                        <div>
                            Code:{" "}
                            <strong className="medium">{props.tag.barcode}</strong>
                        </div>
                        <div>{props.tag.description}</div>
                    </div></React.Fragment>
            }
        </React.Fragment>
    );
};

export default TagLayoutInfo;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/TagLayoutInfo.js